import React, { Component } from 'react';
import CreatableSelect from 'react-select/creatable';
import PropTypes from 'prop-types';
import { ReactSelectStyles, SelectorFilterOptions } from './SelectorUtils';

function NoOptionsMessage(props) {
  return (
    <div color="textSecondary" className={props.selectProps.classes.noOptionsMessage} {...props.innerProps}>
      {props.children}
    </div>
  );
}

NoOptionsMessage.propTypes = {
  children: PropTypes.node,
  innerProps: PropTypes.object,
  selectProps: PropTypes.object.isRequired,
};

function Placeholder(props) {
  return (
    <div color="textSecondary" className={props.selectProps.classes.placeholder} {...props.innerProps}>
      {props.children}
    </div>
  );
}

Placeholder.propTypes = {
  children: PropTypes.node,
  innerProps: PropTypes.object,
  selectProps: PropTypes.object.isRequired,
};

function ValueContainer(props) {
  return <div className={props.selectProps.classes.valueContainer}>{props.children}</div>;
}

ValueContainer.propTypes = {
  children: PropTypes.node,
  selectProps: PropTypes.object.isRequired,
};

const trimTagValue = value => {
  if (value != null && typeof value === 'string') {
    return value.trim();
  } else {
    return value;
  }
};

export default class ReactSelector extends Component {
  state = {
    selectedTags: this.props.preSelected,
    noOptionsMessage: 'No Options',
  };

  handleChangeMulti = value => {
    if (value != null) {
      value.forEach(val => {
        val.key = trimTagValue(val.key);
        val.label = trimTagValue(val.label);
        val.value = trimTagValue(val.value);
      });
    }
    this.setState(
      {
        selectedTags: value,
      },
      () => {
        this.props.onUpdateTags(this.state.selectedTags);
      },
    );
  };

  isValidNewOption = (inputValue, value, options) => {
    let isValid = true;

    if (!inputValue.length) {
      if (this.state.noOptionsMessage !== 'No Options.') {
        this.setState({ noOptionsMessage: 'No Options.' });
      }
      isValid = false;
    } else if (!inputValue.match('^[a-zA-Z0-9-\\/_&()?!:@#\\s]*$') || inputValue.startsWith(' ')) {
      if (this.state.noOptionsMessage !== 'Invalid Tag Name.') {
        this.setState({ noOptionsMessage: 'Invalid Tag Name.' });
      }
      isValid = false;
    } else {
      options.concat(value).forEach(val => {
        if (!inputValue.length || inputValue.toLowerCase().trim() === val.label.toLowerCase().trim()) {
          if (this.state.noOptionsMessage !== 'Tag already exists.') {
            this.setState({ noOptionsMessage: 'Tag already exists.' });
          }
          isValid = false;
        }
      });
    }
    return isValid;
  };

  noOptionsMessage = () => {
    return this.state.noOptionsMessage;
  };

  render() {
    return (
      <CreatableSelect
        autoFocus={this.props.focus}
        isDisabled={this.props.isReadOnly}
        styles={ReactSelectStyles}
        inputId="react-select-multiple"
        TextFieldProps={{
          label: 'Tags',
          InputLabelProps: {
            htmlFor: 'react-select-multiple',
            shrink: true,
          },
        }}
        placeholder={'Define Tags...'}
        options={this.props.options}
        value={this.props.preSelected}
        onChange={this.handleChangeMulti}
        isMulti
        isSearchable
        filterOption={SelectorFilterOptions}
        isValidNewOption={this.isValidNewOption}
        noOptionsMessage={this.noOptionsMessage}
        menuPortalTarget={this.props.menuPortalTarget}
      />
    );
  }
}
